import React, {Component} from 'react'
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AlertConfirm from "../modals/Confirm";
import CountrySelect from "react-bootstrap-country-select";
import Error from "../single_components/Error";
import {array} from "yup";
import doctorApi from "../../services/ApiServices/doctorApi";
import SvGraphics from "../../assets/SvGraphics";

class RegisterPatientDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,

        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    componentDidMount() {
    }


    render() {
        let {entry} = this.state
        let {t} = this.props


        return (
            <div className={'patientsFormBoxes'}>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_boarding.id_number')}*</label>
                            <Error isShown={!!(this.props.errors)['ID_passport']}
                                   errorMessage={(this.props.errors)['ID_passport']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text" name="ID" defaultValue={entry.ID_passport}
                               maxLength={9}
                               onChange={(event) => this.props.onValueChange("ID_passport", event.target.value)}/>

                    </div>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_boarding.first_name')}*</label>
                            <Error isShown={!!(this.props.errors)['First_name']}
                                   errorMessage={(this.props.errors)['First_name']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text" name="First_name" defaultValue={entry.First_name}
                               maxLength={20}
                               onChange={(event) => this.props.onValueChange("First_name", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_boarding.last_name')}*</label>
                            <Error isShown={!!(this.props.errors)['Last_name']}
                                   errorMessage={(this.props.errors)['Last_name']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text" name="Last_name" defaultValue={entry.Last_name}
                               maxLength={20}
                               onChange={(event) => this.props.onValueChange("Last_name", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_boarding.Phone_num')}*</label>
                            <Error isShown={!!(this.props.errors)['Phone_num1']}
                                   errorMessage={(this.props.errors)['Phone_num1']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text" name="Phone_num1" defaultValue={entry.Phone_num1}
                               maxLength={20}
                               onChange={(event) => this.props.onValueChange("Phone_num1", event.target.value)}/>
                    </div>

                </div>
                <div className={'patientsFormRow'}>

                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_boarding.Email')}*</label>
                            <Error isShown={!!(this.props.errors)['Email']}
                                   errorMessage={(this.props.errors)['Email']}/>
                        </div>

                        <input className={'inputBoxStyle'} type="email" name="Email" defaultValue={entry.Email}
                               maxLength={50}
                               onChange={(event) => this.props.onValueChange("Email", event.target.value)}/>
                    </div>
                </div>

            </div>

        )
    }
}

RegisterPatientDetails.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default RegisterPatientDetails;
